let storedCourse = sessionStorage.getItem('idCourseEdit');

const initialState = {
  id: storedCourse ? storedCourse : null,
  edit: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_ID_COURSE':
      sessionStorage.setItem('idCourseEdit', action.payload);
      return {...state, id: action.payload};
    case 'MODE':
      return {...state, edit: action.payload};
    default:
      return state;
  }
};

export default reducer;
